export default __webpack_public_path__ + "static/media/salesforceHardDecline.a34667d8.png";